import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { PayrollService } from "src/app/services/payroll.service";
import { ArrearsDeductionDetail, BenefitDeductionDetail, DeductionsModel, MiscDeductionDetail, WageAttachmentDeductionDetail } from "src/app/models/payroll";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumn } from "src/app/models/table";
import { TableColumnType } from "src/app/constants/table";
import { TextType } from "src/app/constants/text-type";

@Component({
    selector: 'mwp-payroll-deductions',
    templateUrl: './deductions.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PayrollDeductionsComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PayrollDeductions;
    public deductions: DeductionsModel;

    public miscellaneousDeductionsMatTableData: MatTableDataSource<MiscDeductionDetail>;
    public wageAttachmentsMatTableData: MatTableDataSource<WageAttachmentDeductionDetail>;
    public benefitDeductionsMatTableData: MatTableDataSource<BenefitDeductionDetail>;
    public arrearsMatTableData: MatTableDataSource<ArrearsDeductionDetail>;
    public showMiscTable: Boolean;
    public showBenefitTable: Boolean;
    public showWageTable: Boolean;
    public showArrearsTable: Boolean;

    public miscellaneousDeductionsColumns: TableColumn[] = [
        {
            columnName: 'Deduction',
            propertyId: 'deduction',
            columnType: TableColumnType.label,
            width: "85%"
        },
        {
            columnName: 'Amount',
            propertyId: 'amount',
            textType: TextType.currency,
            columnType: TableColumnType.label,
            cssCustomClass: 'd-flex justify-content-end pe-1',
            cssCustomHeaderClass: 'd-flex justify-content-end pe-1',
        },];
    public wageAttachmentsDeductionsColumns: TableColumn[] = [
        {
            columnName: 'Wage Attachments',
            propertyId: 'agencyName',
            columnType: TableColumnType.label,
            width: "85%"
        },
        {
            columnName: 'Amount',
            propertyId: 'amount',
            columnType: TableColumnType.label,
            cssCustomClass: 'd-flex justify-content-end pe-1',
            cssCustomHeaderClass: 'd-flex justify-content-end pe-1',
        },];
    public benefitDeductionsColumns: TableColumn[] = [
        {
            columnName: 'Benefit Category',
            propertyId: 'deduction',
            columnType: TableColumnType.label,
            width: "85%"
        },
        {
            columnName: 'Amount',
            propertyId: 'amount',
            textType: TextType.currency,
            columnType: TableColumnType.label,
            cssCustomClass: 'd-flex justify-content-end pe-1',
            cssCustomHeaderClass: 'd-flex justify-content-end pe-1',
        },];
    public arrearsColumns: TableColumn[] = [
        {
            columnName: 'Deduction Type',
            propertyId: 'deduction',
            columnType: TableColumnType.label,
            width: "85%"
        },
        {
            columnName: 'Amount',
            propertyId: 'amount',
            textType: TextType.currency,
            columnType: TableColumnType.label,
            cssCustomClass: 'd-flex justify-content-end pe-1',
            cssCustomHeaderClass: 'd-flex justify-content-end pe-1',
        },];

    constructor(
        private payrollService: PayrollService,
    ) { }


    ngOnInit(): void {
        this.payrollService.getDeductions().subscribe((response: DeductionsModel) => {
            this.deductions = response;
            if (response.miscDeductions?.length > 0) {
                this.showMiscTable = true;
                this.miscellaneousDeductionsMatTableData = new MatTableDataSource(response.miscDeductions);

            }
            if (response.wageAttachmentDeductions?.length > 0) {
                this.showWageTable = true;
                this.wageAttachmentsMatTableData = new MatTableDataSource(response.wageAttachmentDeductions);
            }

            if (response.benefitDeductions?.length > 0) {
                this.showBenefitTable = true;
                this.benefitDeductionsMatTableData = new MatTableDataSource(response.benefitDeductions);
            }

            if (response.arrearsDeductions?.length > 0) {
                this.showArrearsTable = true;
                this.arrearsMatTableData = new MatTableDataSource(response.arrearsDeductions);
            }
        });
    }
}